import {Component, Input} from '@angular/core';

import {AbstractCustomPropertyView} from '../abstract-custom-property-view';

@Component({
  selector: 'ax-custom-check-view',
  template: `@if (isSingleCheckbox) {
      <mat-checkbox class="check" [checked]="checked" [disabled]="true">
        {{ requestedPropertyTypeDescription?.customFieldDescription?.label }}
      </mat-checkbox>
    } @else {
      <ax-custom-labels-view
        [property]="property"
        [requestedPropertyType]="requestedPropertyType"
        [requestedPropertyTypeDescription]="requestedPropertyTypeDescription"
        [isInListView]="isInListView"
        [isOwner]="isOwner"
      ></ax-custom-labels-view>
    }`,
})
export class CustomCheckViewComponent extends AbstractCustomPropertyView {
  @Input()
  override isInListView = false;

  get isSingleCheckbox() {
    return this.valueLabels.length < 1;
  }

  get checked() {
    return this.property.value?.toLowerCase() !== 'false';
  }
}
